<template>
  <div class="favorite-page">
    <div class="inner-text">来不及学习签证知识？</div>
    <div class="btn-text">ctrl</div>
    <div class="inner-text">+</div>
    <div class="btn-text">D</div>
    <div class="inner-text">收藏当前页面，学习不止于此</div>
  </div>
</template>

<script>
export default {
  name: "favorite-page",
};
</script>

<style lang="less" scoped>
.favorite-page {
  width: 100%;
  height: 60px;
  background-color: #f3f6f9;
  display: flex;
  align-items: center;
  justify-content: center;
  .inner-text {
    font-size: 16px;
    font-weight: 400;
    color: #2f333d;
    line-height: 22px;
  }
  .btn-text {
    padding: 0 13px;
    margin: 0 8px;
    height: 30px;
    border-radius: 2px;
    border: 1px solid #2f333d;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/components/favorite-page.vue